module.exports = __webpack_public_path__ + "public/images/download-on-appstore.28795fc1cd090e188cc9f6b5be28e561.svg";